import { COMPONENT_TYPE as TYPE } from 'common/constants';
import View from 'client/components/common/BuildingBlocks/Login/GoogleLogin/GoogleLogin';
import { generateElementId, generateNodeId } from 'client/components/common/BuildingBlocks/utils/common';

/**
 * @param options {Object=}
 * @param options.dictionary {Object=}
 * @returns {{ view, model }}
 * @constructor
 */
export const GOOGLE_LOGIN = (options = { dictionary: {} }) => {
	const _id = generateElementId();

	return {
		view: View,
		get model() {
			const type = TYPE.GOOGLE_LOGIN;

			return {
				_id,
				type,
				uiConfig: {
					layer: undefined,
					editorProps: {
						name: GOOGLE_LOGIN.displayName,
						selectable: true,
						draggable: true,
						expandable: false,
						expanded: false,
					},
					nodeProps: {
						id: generateNodeId(_id, GOOGLE_LOGIN.displayName),
					},
					componentProps: {
						other: {},
						styles: {},
					},
				},
				children: [],
			};
		},
	};
};

GOOGLE_LOGIN.displayName = 'Google login';
